import React from 'react';
import { GapDetailLine, GapAssignmentDetail } from '../Onboarding/ContentInventory/Components/GapAssignmentJoin';
import { ShieldConfidenceBadge } from './GapConfidenceBadge';

function GapDetailLineRow({ line }: { line: GapDetailLine }) {
  if (line.status === 'removed') {
    return (
      <div className="py-2" data-testid={`gap-detail-section-${line.kind}`}>
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-slate-500 line-through">{line.label}</span>
          <span className="rounded bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500">Removed by user</span>
        </div>
      </div>
    );
  }

  return (
    <div className="py-2" data-testid={`gap-detail-section-${line.kind}`}>
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-slate-900">{line.label}</span>
        {line.status === 'missing' ? (
          <span className="rounded bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500">Not detected</span>
        ) : line.confidence !== null ? (
          <ShieldConfidenceBadge confidence={line.confidence} />
        ) : null}
      </div>
      <div className="mt-1 text-sm text-slate-600">
        {line.status === 'missing' ? line.text || 'This was not found on the page.' : line.text || '—'}
      </div>
    </div>
  );
}

/**
 * Inline detail panel revealed beneath a gap row. Both AI and formula checks render the same
 * two-line shape — "Should have" (the requirement / suggestion) and "Has" (the page state).
 */
export function GapAssignmentDetails({ id, detail }: { id: string; detail: GapAssignmentDetail }) {
  return (
    <div id={id} role="region" aria-label="Gap assignment details" className="px-6 py-3" data-testid="gap-assignment-details">
      <div className="divide-y divide-slate-100">
        {detail.sections.map((line) => (
          <GapDetailLineRow key={line.kind} line={line} />
        ))}
      </div>
    </div>
  );
}
